<template lang="pug">
  div
    .d-flex
      small.usuarios-label.text-ellipsis(@click='open' :class="{ 'text-capitalize': value.length > 0 }") {{ label }}
    .modal.modal-md(:class='{active: active}')
      a.modal-overlay(aria-label='Fechar' @click='close')
      .modal-container
        .modal-header
          a.btn.btn-clear.float-right(aria-label='Fechar' @click='close')
          .h5.modal-title Selecionar usuários
            .column.col-auto
        .modal-body
          .content
            spinner.text-center(:loading="loading" )
            .empty(v-if='!loading && list.length === 0')
              .empty-icon
                i.icon.icon-people
              p.empty-title.h5 Nenhum usuário encontrado
              p.empty-subtitle Selecione outro grupo
            table.table.table-striped.table-hover.table-sm(v-else)
              tbody
                tr.c-hand(v-for="item in list" @click='select(item)')
                  td \#{{item.id}}
                  td {{item.nome}}
                  td.check-column
                    .fa.fa-check.text-success(v-if='value.includes(item.id)')
        .modal-footer
          button.btn(type='button' @click='close') OK
</template>

<script>
import UsuariosApi from '@/api/sistema/usuarios'

export default {
  props: {
    value: { type: Array, required: true },
    usuario_grupo_id: { type: Number, required: true },
  },

  data() {
    return {
      active: false,
      loading: false,
      list: [],
    }
  },

  computed: {
    label() {
      return this.value.length > 0
        ? this.list
            .filter(usuario => this.value.includes(usuario.id))
            .map(usuario =>
              usuario.nome
                .split(' ')
                .shift()
                .toLowerCase(),
            )
            .join(', ')
        : 'Selecione os usuários do grupo...'
    },
  },

  methods: {
    open() {
      this.active = true
    },
    close() {
      this.active = false
    },

    select(item) {
      if (this.value.includes(item.id)) {
        this.$emit(
          'input',
          this.value.filter(p => item.id !== p),
        )
      } else {
        this.$emit('input', [...this.value, item.id])
      }
    },

    selectAll() {
      this.$emit(
        'input',
        this.list.map(usuario => usuario.id),
      )
    },

    async fetchList() {
      try {
        this.loading = true
        const { rows } = await UsuariosApi.fiscais({
          q: {
            usuario_grupo_id_eq: this.usuario_grupo_id,
          },
        })
        this.list = rows
        this.selectAll()
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
  },

  mounted() {
    this.fetchList()
  },

  watch: {
    usuario_grupo_id() {
      this.fetchList()
    },
  },
}
</script>
<style lang="stylus" scoped>
.check-column
  min-width 20px

.usuarios-label
  color #4285f4
  text-decoration underline
  cursor pointer
</style>
